<div
  #originRef
  (click)="showPopover(originRef)"
  [class.bg-hover]="dropdownOpen"
  class="flex items-center rounded cursor-pointer relative transition duration-400 ease-out-swift select-none py-1 pr-1 pl-3 hover:bg-hover"
  matRipple>
  <div
    class="body-1 font-medium leading-snug ltr:mr-3 rtl:ml-3 hidden sm:block">
    <ng-container *ngIf="currentUser$ | async as user; else guestTemplate">
      {{ getUserDisplayName(user) }}
    </ng-container>
    <ng-template #guestTemplate>
      Usuario Invitado
    </ng-template>
  </div>
  <ng-container *ngIf="currentUser$ | async as user; else defaultAvatar">
    <ng-container *ngIf="user.imagen; else initialsAvatar">
      <div class="rounded-full h-9 w-9 flex-none overflow-hidden">
        <img [src]="user.imagen" class="w-full h-full object-cover" alt="Avatar" />
      </div>
    </ng-container>
    <ng-template #initialsAvatar>
      <div
        class="rounded-full h-9 w-9 flex items-center justify-center text-sm font-bold flex-none select-none"
        [style.background-color]="getAvatarColor(user)"
        [style.color]="'#374151'">
        {{ getInitials(user) }}
      </div>
    </ng-template>
  </ng-container>
  <ng-template #defaultAvatar>
    <div class="rounded-full h-9 w-9 flex items-center justify-center text-primary-600 bg-primary-600/10">
      <mat-icon svgIcon="mat:person"></mat-icon>
    </div>
  </ng-template>
</div>
